import { showToastWarning } from "utilities/toastUtil"

// Shared across the OR/PO/PR "approve / reject / info_request / resubmit"
// action flows. An info_request can carry a deadline; once that deadline has
// passed the backend auto-rejects the entity the next time anything touches
// it (typically a resubmit, but any action can land on it) — HTTP status is
// still 200, so a resolved `.unwrap()` is not by itself proof the action did
// what the user expected. Only the explicit `reject` action is supposed to
// land on the rejected status; anything else landing there was a backend
// override and must not be reported with a green success toast.
//
// `result` is the flattened detail object each *Action mutation resolves to
// (it carries `.status`). `rejectedStatus` is that domain's REJECTED status
// constant (ORDER_STATUS.REJECTED / PO_STATUS.REJECTED /
// PAYMENT_REQUEST_STATUS.REJECTED).
export const isAutoRejectedOutcome = (action, result, rejectedStatus) =>
  action !== "reject" && result?.status === rejectedStatus

// RFQ creation returns one proposal per supplier; a supplier without an email
// gets no invitation, and the backend says so in `inviteEmailMessage`.
export const warnMissingInviteEmails = (proposals) =>
  (Array.isArray(proposals) ? proposals : [])
    .filter((p) => p?.inviteEmailStatus === "missing_email" && p.inviteEmailMessage)
    .forEach((p) => showToastWarning(p.inviteEmailMessage))

export const AUTO_REJECT_MESSAGE =
  "The info-request deadline already passed, so this was automatically rejected instead."
